// @see mylw-cyan2.nexcess-internal.workers.dev
import devTemplate from './dev';
import type { AppConfigI } from './example';

const cyan2: AppConfigI = {
	...devTemplate,
	baseURL: 'https://api-public.devqa2.dev.liquidweb.com/',
	hosts: {
		...devTemplate.hosts,
		cart: 'cart.devqa2.dev.liquidweb.com',
		manage: 'manage.devqa2.dev.liquidweb.com',
	},
	openId: {
		client_id: 'mylw-cyan2-cp',
		authority: 'https://login.dev.liquidweb.com',
		accessTokenExpiringNotificationTime: 1200,
	},
};

export default cyan2;
